import React, { useEffect, useRef, useState } from "react";
import { Button } from "components/UI/buttons/Button";
import s from "./SearchForm.module.scss";
import { useAppDispatch, useAppSelector } from "store";
import { setSearchTerm } from "store/samplesSearch/samplesSearchSlice";
import { SpriteIcon } from "@/components/UI/SpriteIcon";
import searchIcon from "@/public/img/icons/search.svg";
import { useSampleFilterContext } from "@/components/SampleFilterContext";
import { usePathname } from "next/navigation";
import { useRedirect } from "@/utils/useRedirect";
import { isRedirectionSelector, setIsRedirecting } from "@/store/global/globalSlice";

export const SearchForm = () => {
  const inputRef = useRef<HTMLInputElement>(null);
  const dispatch = useAppDispatch();
  const pathname = usePathname();
  const isRedirecting = useAppSelector(isRedirectionSelector);

  const [loading, setLoading] = useState(false);

  const context = useSampleFilterContext();

  const redirect = useRedirect();

  const isHomePage = pathname === "/";

  const selectedValues = context?.selectedValues;
  const onValueChange = context?.onValueChange;

  const defaultValue = isHomePage ? "" : selectedValues?.title ? String(selectedValues?.title) : "";

  const onClickHandler = () => {
    if (!inputRef.current) return;

    if (isHomePage) {
      if (!inputRef.current.value.trim()) return;
      setLoading(true);
      redirect(`/search?title=${inputRef.current.value}`);
    } else {
      onValueChange?.({ ...selectedValues, title: inputRef.current.value });
    }

    dispatch(setSearchTerm(inputRef.current.value));
  };

  useEffect(() => {
    if (isHomePage) return;
    dispatch(setSearchTerm(defaultValue || ""));
  }, [isHomePage, dispatch, defaultValue]);

  return (
    <div className={s.wrapper}>
      <SpriteIcon icon={searchIcon} className={s.icon} />
      <input
        ref={inputRef}
        defaultValue={defaultValue}
        type="search"
        placeholder="Find sample by topic, subject, keyword"
        className={s.input}
        onKeyDown={(event) => {
          if (event.key === "Enter") onClickHandler();
        }}
      />
      <Button
        type="accent"
        tag="button"
        className={s.button}
        onClick={onClickHandler}
        loading={loading || isRedirecting}
      >
        Search
      </Button>
    </div>
  );
};
